<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="用户id" prop="memberId">
          <el-input v-model="dataForm.memberId" placeholder="用户id"></el-input>
      </el-form-item>
          <el-form-item label="0买家匹配，1卖家匹配" prop="type">
          <el-input v-model="dataForm.type" placeholder="0买家匹配，1卖家匹配"></el-input>
      </el-form-item>
          <el-form-item label="优果数" prop="integrationAmount">
          <el-input v-model="dataForm.integrationAmount" placeholder="优果数"></el-input>
      </el-form-item>
          <el-form-item label="优果手续费" prop="serviceCharge">
          <el-input v-model="dataForm.serviceCharge" placeholder="优果手续费"></el-input>
      </el-form-item>
          <el-form-item label="买方价格类型
0 官方指导价
1 自主溢价" prop="priceType">
          <el-input v-model="dataForm.priceType" placeholder="买方价格类型
0 官方指导价
1 自主溢价"></el-input>
      </el-form-item>
          <el-form-item label="买家价格" prop="price">
          <el-input v-model="dataForm.price" placeholder="买家价格"></el-input>
      </el-form-item>
          <el-form-item label="卖家手机号" prop="mobile">
          <el-input v-model="dataForm.mobile" placeholder="卖家手机号"></el-input>
      </el-form-item>
          <el-form-item label="卖方银行卡id" prop="bankId">
          <el-input v-model="dataForm.bankId" placeholder="卖方银行卡id"></el-input>
      </el-form-item>
          <el-form-item label="匹配状态
0 匹配中
1 匹配成功
2 已取消
" prop="status">
          <el-input v-model="dataForm.status" placeholder="匹配状态
0 匹配中
1 匹配成功
2 已取消
"></el-input>
      </el-form-item>
          <el-form-item label="创建时间" prop="createTime">
          <el-input v-model="dataForm.createTime" placeholder="创建时间"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        memberId: '',
        type: '',
        integrationAmount: '',
        serviceCharge: '',
        priceType: '',
        price: '',
        mobile: '',
        bankId: '',
        status: '',
        createTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        memberId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        integrationAmount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        serviceCharge: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        priceType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        price: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bankId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/csm/matching/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/csm/matching/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
